import { get, add } from '../Context/dist/effect-Context.esm.js';
import { dual } from '../Function/dist/effect-Function.esm.js';
import { fiberRefGetWith, fiberRefLocallyWith, acquireUseRelease, isEffect } from './core.esm.js';
import { currentServices } from './defaultServices.esm.js';
import { consoleTag } from './defaultServices/console.esm.js';
import { fiberRefLocallyScopedWith, acquireRelease } from './fiberRuntime.esm.js';
import { scopedDiscard } from './layer.esm.js';

/** @internal */
const consoleWith = f => fiberRefGetWith(currentServices, services => f(get(services, consoleTag)));

/** @internal */
const withConsole = /*#__PURE__*/dual(2, (effect, value) => fiberRefLocallyWith(effect, currentServices, add(consoleTag, value)));

/** @internal */
const setConsole = console => scopedDiscard(fiberRefLocallyScopedWith(currentServices, add(consoleTag, console)));

/** @internal */
const assert = (condition, ...args) => consoleWith(_ => _.assert(condition, ...args));

/** @internal */
const clear = /*#__PURE__*/consoleWith(_ => _.clear);

/** @internal */
const count = label => consoleWith(_ => _.count(label));

/** @internal */
const countReset = label => consoleWith(_ => _.countReset(label));

/** @internal */
const debug = (...args) => consoleWith(_ => _.debug(...args));

/** @internal */
const dir = (item, options) => consoleWith(_ => _.dir(item, options));

/** @internal */
const dirxml = (...args) => consoleWith(_ => _.dirxml(...args));

/** @internal */
const error = (...args) => consoleWith(_ => _.error(...args));

/** @internal */
const group = options => consoleWith(_ => acquireRelease(_.group(options), () => _.groupEnd));

/** @internal */
const info = (...args) => consoleWith(_ => _.info(...args));

/** @internal */
const log = (...args) => consoleWith(_ => _.log(...args));

/** @internal */
const table = (tabularData, properties) => consoleWith(_ => _.table(tabularData, properties));

/** @internal */
const time = label => consoleWith(_ => acquireRelease(_.time(label), () => _.timeEnd(label)));

/** @internal */
const timeLog = (label, ...args) => consoleWith(_ => _.timeLog(label, ...args));

/** @internal */
const trace = (...args) => consoleWith(_ => _.trace(...args));

/** @internal */
const warn = (...args) => consoleWith(_ => _.warn(...args));

/** @internal */
const withGroup = /*#__PURE__*/dual(args => isEffect(args[0]), (self, options) => consoleWith(_ => acquireUseRelease(_.group(options), () => self, () => _.groupEnd)));

/** @internal */
const withTime = /*#__PURE__*/dual(args => isEffect(args[0]), (self, label) => consoleWith(_ => acquireUseRelease(_.time(label), () => self, () => _.timeEnd(label))));

export { assert, clear, consoleWith, count, countReset, debug, dir, dirxml, error, group, info, log, setConsole, table, time, timeLog, trace, warn, withConsole, withGroup, withTime };
